<div class="d-flex">
    <p-dropdown *ngIf="code" [formControl]="getCodeControl" [options]="codes" [filter]="true" filterBy="name,number"
        filterPlaceholder="ค้นหาประเทศ/รหัส เช่น 66 หรือ Thailand" optionValue="number" optionLabel="number"
        appendTo="body" panelStyleClass="phone-code-panel">
        <ng-template pTemplate="selectedItem">
            <div class="d-flex align-items-center">
                {{ code.value ? '+' + code.value : '&nbsp;' }}
            </div>
        </ng-template>
        <ng-template let-phone pTemplate="item">
            <div class="phone-item">
                <div>(+{{ phone.number }}) {{ phone.name }}</div>
            </div>
        </ng-template>
    </p-dropdown>

    <span *ngIf="phone" class="w-100">
        <input *ngIf="!hasMask" type="text" class="w-100" [formControl]="getPhoneControl" pInputText
            placeholder="หมายเลขโทรศัพท์">
        <p-inputMask *ngIf="hasMask" styleClass="w-100" [formControl]="getPhoneControl" [mask]="getMask"
            placeholder="หมายเลขโทรศัพท์"></p-inputMask>
    </span>
</div>
